var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallingFrameLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 991 958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#97675e;}.cls-2{fill:#173856;}.cls-3{fill:#20456e;}.cls-4{fill:#639;}.cls-5{fill:#28110b;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "au sol miroir") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_16",
    "data-name": "Calque 16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1086.48,1469.84s20.48,72.29-23.27,69.13-33.31-70-33.31-70Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1079.89,1279.92s-38.73-75.85-87.9-14.11L1016.85,1477s44.71,14.52,78-4C1090.77,1397.83,1079.89,1279.92,1079.89,1279.92Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M980.58,1475.26l100.1-176.6s24.65-43.5-32.77-76.05-77.14,2.26-77.14,2.26l-105,185.31Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M658.68,1387.93s171.71-14.22,229.64,26c-26.69,32.41-3.75,102.38-26.73,105.08-34,4-92.11-12.07-92.11-12.07s-80.24-20.45-121.32-10.38c0,0-6.67,7.84-16.15,8.19s-57.47-5.14-57.47-5.14l15.07-173.34S672.71,1322.86,658.68,1387.93Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M842.55,1533.83s-96.06-37.21-192.25-16.1c-5.31,13-81.24,11-81.24,11l-4.7-170.51s64.17-11.53,71.45,49.81c53.94-10.31,198-20.1,257.2,4.17,2.9,29.88,86.25,34.54,88,62.79C955,1576,842.55,1533.83,842.55,1533.83Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1043.37,1478.26s7.59,74.74-34.94,64-20.64-74.69-20.64-74.69Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1069.88,1290.08s-25-81.42-84.1-29.17l-12.23,212.27s41.51,22.07,77.5,9.65C1060.1,1408.08,1069.88,1290.08,1069.88,1290.08Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1074.66,1243.58c-5.8-7.2-14.17-14.41-26.07-21.15-57.42-32.55-78.88,1.27-78.88,1.27S995.09,1209.34,1074.66,1243.58Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 859.82,
    y: 1435.05,
    width: 132,
    height: 8,
    transform: "translate(513.7 2526.51) rotate(-150.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 419,
    r: 169
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1046.79,1124l10,77.13s157-27.13,134-204.13c-13.94-107.25-110.8-146.53-194-140-26.28,2.06-70.79,18.2-101,41a195.79,195.79,0,0,0-49,55l103,42,58,81s27.67-26.15,54-14C1087.79,1074,1081.79,1128,1046.79,1124Z",
    transform: "translate(-508 -621)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 991,
    height: 958
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallingFrameLeft2);
export default __webpack_public_path__ + "static/media/falling_frame_left_2.1d9d4b25978cb0f51d771e5786cddb06.svg";
export { ForwardRef as ReactComponent };